import React, { useState } from 'react'

import 'react-circular-progressbar/dist/styles.css'
import { CircularProgressbar } from 'react-circular-progressbar'

import { Accordion, AccordionItem } from '../components/Accordion'
import UIStaightlineProressBar from '../../../components/UI/UIStaightlineProressBar'
import UIButton from '../../../components/UI/UIButton'
import UICheckbox from '../../../components/UI/UICheckBox'

import { Icon } from '../../../components/Icon'
import UISubHeaderComponent from '../../../components/UI/UISubHeaderComponent'
import PoliciesLargeButton from '../components/PoliciesLargeButton'
import { useQuery } from 'react-query'
import { getPolicyAgreement, getPolicyData, getPolicyDataById } from './apiCall'
import { formatDate } from '../../../utils/utils'
import UiPdfViewer from '../../../components/UiPdfViewer'
import { getPolicyType, policiesAgreement } from '../../../utils/types'
import { createPolicyAgreement } from '../../../api/candidate/policies'
import { toast } from 'react-toastify'
import { downloadPDF } from '../../policy/utils'

const Policies = () => {
  const [isView, setIsView] = useState(false)
  const [isChecked, setIsChecked] = useState(false)
  const [id, setId] = useState('')
  const policies = useQuery('policydata1', () => getPolicyData())

  const policyById = useQuery(['policyById', id], () => getPolicyDataById(id), {
    enabled: !!id,
  })

  const policiesAgreement = useQuery('Agreements', () => getPolicyAgreement())

  function containsPolicyId(data: policiesAgreement[], id: string): boolean {
    // Check if the input data is an array
    if (!Array.isArray(data)) {
      throw new Error('Input data must be an array')
    }

    // Check if the id exists in the array of policyIds
    return data.some((item) => item?.policyId === id)
  }

  const addPolicyAgreement = async (): Promise<void> => {
    const response = (await createPolicyAgreement(id)) as {
      status?: string
      data: policiesAgreement
    }
    if (response?.status == 'successful') {
      policies.refetch()
      policiesAgreement.refetch()
      toast.success('Policy Agreed.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  const policyAgreementIds = policiesAgreement?.data?.map((item) => {
    return item?.policyId
  })

  function calculateCommonIdsPercentage(
    arrayOfObjects: getPolicyType[],
    policyAgreementIds: string[]
  ): { percentage: number; color: string } {
    // Step 1: Extract ids from array of objects
    let percentage: number
    let color: string
    if (policyAgreementIds.length == 0) {
      percentage = 0
      color = 'red'
    } else {
      const objectIds = arrayOfObjects?.map((obj) => obj.id)

      // Step 2: Check for common ids
      const commonIds = objectIds?.filter((policyId) =>
        policyAgreementIds?.includes(policyId)
      )

      // Step 3: Calculate percentage
      percentage = (commonIds?.length / arrayOfObjects?.length) * 100

      if (percentage >= 95) {
        color = '#01B38B'
      } else if (percentage >= 40) {
        color = '#FFA800'
      } else {
        color = '#FF6666'
      }
    }

    return { percentage, color }
  }

  return (
    <div
      className={
        'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-8  '
      }
    >
      {isView == false && (
        <div
          style={{
            height: 'calc(100vh - 100px)',
            overflow: 'auto',
            scrollbarWidth: 'none',
          }}
        >
          <div className={'flex w-full justify-between items-start '}>
            <div className="flex-col w-[48%] gap-[20px] ">
              <p className={'text-lg leading-6 text-text2 font-bold'}>
                Policies
              </p>
              {/* <p className={'text-sm leading-6 font-normal text-text1 mt-2'}>
                This is where all of your policy documents are. You can view
                these files and agree to the terms.
              </p> */}
            </div>
          </div>
          <div className="flex my-8 gap-2">
            {/* First column */}
            <div
              style={{
                height: 'calc(100vh - 100px)',
                overflow: 'auto',
                scrollbarWidth: 'none',
              }}
              className="flex flex-col w-8/12 gap-4"
            >
              {/* <div className="flex items-center gap-3">
                <p className="text-sm text-text2 font-semibold leading-6">
                  Sort by
                </p>
                <div className="rounded-[40px] bg-gray2 py-2 px-4 flex justify-center items-center gap-1 cursor-pointer">
                  <p className={'text-text3 font-medium text-xs leading-5'}>
                    Last Added
                  </p>
                  <Icon
                    name="IconChevronDown"
                    width={16}
                    height={16}
                    strokeWidth={1}
                    stroke={'#67A5B9'}
                  />
                </div>
              </div> */}

              {/* {policies?.data?.data?.map((item, index) =>  */}
              {policies?.data?.data?.map((item, index) => (
                <PoliciesLargeButton
                  key={index}
                  onClick={() => {
                    setId(item.id)
                    setIsView(true)
                  }}
                  title={item.title}
                  icon="IconFileCheckInActive"
                  iconStrokeWidth={1.5}
                  iconSize={24}
                  rightIcon={'IconDownloadCloud'}
                  badgeColor={
                    containsPolicyId(policiesAgreement?.data || [], item.id) ==
                    true
                      ? 'bg-[#CCF0E8]'
                      : 'bg-[#FFD8D8]'
                  }
                  bagdeLabel={
                    containsPolicyId(policiesAgreement?.data || [], item.id) ==
                    true
                      ? 'Agreed'
                      : 'Not Agreed'
                  }
                />
              ))}
            </div>

            {/* Second column */}
            <div className="w-4/12">
              <Accordion defaultActiveIndex={0}>
                <AccordionItem
                  onClick={() => console.log('Accordion')}
                  title={'Scorecard'}
                  isActive={true}
                  AccordionItemStyle={{
                    backgroundColor: 'rgba(230, 240, 243, 1)',
                  }}
                  AccordiontitleStyle={
                    'text-sm text-bluishGreen flex-1 font-semibold'
                  }
                  AccordionItemStyleContainer={{
                    backgroundColor: 'rgba(242, 247, 249, 1)',
                  }}
                  icon={'IconBarChartSquare'}
                >
                  <div className="bg-gray1 flex items-center flex-col justify-center gap-4 my-8">
                    <div className="w-[160px] h-[160px]">
                      <CircularProgressbar
                        strokeWidth={5}
                        value={Number(
                          calculateCommonIdsPercentage(
                            policies?.data?.data && policies
                              ? policies?.data?.data
                              : [],
                            policyAgreementIds || []
                          ).percentage.toFixed(0)
                        )}
                        text={`${Number(calculateCommonIdsPercentage(policies?.data?.data && policies ? policies?.data?.data : [], policyAgreementIds || []).percentage.toFixed(0))}%`}
                        styles={{
                          root: {},
                          path: {
                            stroke: calculateCommonIdsPercentage(
                              policies?.data?.data && policies
                                ? policies?.data?.data
                                : [],
                              policyAgreementIds || []
                            ).color,
                            transition: 'stroke-dashoffset 0.5s ease 0s',
                          },
                          text: {
                            fill: '#013546',
                            fontSize: '24px',
                            fontWeight: 700,
                            lineHeight: 40,
                          },
                        }}
                      />
                    </div>
                    <Accordion defaultActiveIndex={0}>
                      <AccordionItem
                        onClick={() => console.log('Accordion')}
                        title={'Your score is broken down as follows:'}
                        isActive={false}
                        AccordionItemStyle={{ backgroundColor: '#FFFFFF' }}
                        AccordiontitleStyle={
                          'text-xs font-semibold text-text4 leading-5 flex-1'
                        }
                        AccordionItemStyleContainer={{
                          backgroundColor: '#FFFFFF',
                        }}
                      >
                        <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                          {policies?.data?.data
                            ?.filter((item) => item.status !== 'unpublish')
                            ?.map((item, index) => (
                              <div key={index} className="mt-3">
                                <UIStaightlineProressBar
                                  percentage={
                                    containsPolicyId(
                                      policiesAgreement?.data || [],
                                      item.id
                                    ) == true
                                      ? 100
                                      : 0
                                  }
                                  label={item.title}
                                  stroke={
                                    containsPolicyId(
                                      policiesAgreement?.data || [],
                                      item.id
                                    ) == true
                                      ? '#01B38B'
                                      : ''
                                  }
                                  strokeWidth={1.5}
                                />
                              </div>
                            ))}
                        </div>
                      </AccordionItem>
                    </Accordion>
                  </div>
                </AccordionItem>
              </Accordion>
            </div>
          </div>
        </div>
      )}
      {isView == true && (
        <div
          style={{
            height: 'calc(100vh - 100px)',
            overflow: 'auto',
            // scrollbarWidth: 'none',
          }}
        >
          <UISubHeaderComponent
            mainPage="Policies"
            subPage={policyById?.data?.title}
            copy="Please ensure that you read the following policy, and please tick that you have read and understood the policy:"
            onDelete={() => {}}
            isViewMode={false}
            isCreatePolicy={false}
            onBack={() => {
              setIsView(false)
            }}
          />
          <div className="flex flex-col my-8 gap-4">
            <div className="bg-gray1 rounded-xl">
              <div className="py-3 px-4 flex gap-2 items-center bg-gray2 rounded-xl rounded-b-none">
                <Icon
                  name="IconFileCheck"
                  width={16}
                  height={16}
                  strokeWidth={1}
                  stroke={'#02698C'}
                />
                <p className="text-sm font-semibold text-text2 flex-1">
                  Policy Document
                </p>
                <span
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    policyById?.data?.policyDocumentUrl &&
                    downloadPDF(
                      policyById?.data?.policyDocumentUrl,
                      'download.pdf'
                    )
                  }
                >
                  <Icon
                    name="IconDownloadCloud"
                    width={16}
                    height={16}
                    strokeWidth={1}
                    stroke={'#02698C'}
                  />
                </span>
              </div>
              <div className="p-4 px-40">
                <UiPdfViewer url={policyById?.data?.policyDocumentUrl || ''} />
              </div>
            </div>

            <div>
              <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
                <table className="rounded-[16px] overflow-hidden border w-full border-white">
                  <tbody>
                    <tr className="bg-gray1">
                      {/* Example row */}
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Related Policy Document
                      </td>
                      <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                        <div className=" w-[268px] h-[48px] flex gap-2 items-center  rounded-lg">
                          <Icon
                            name="IconFile"
                            width={16}
                            height={16}
                            strokeWidth={2}
                            stroke={'#02698C'}
                          />
                          <p className="text-sm font-semibold text-bluishGreen leading-6 flex-1">
                            {
                              policyById?.data?.otherInformation
                                ?.relatedPolicyDocuments
                            }
                            <span className="text-xs font-medium leading-5 text-text3">
                              1.7 MB
                            </span>
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr className="bg-gray1">
                      {/* Example row */}
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Owner
                      </td>
                      <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                        {policyById?.data?.otherInformation.owner}
                      </td>
                    </tr>
                    <tr className="bg-gray1">
                      {/* Example row */}
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Version
                      </td>
                      <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                        {policyById?.data?.otherInformation.version}
                      </td>
                    </tr>

                    <tr className="bg-gray1">
                      {/* Example row */}
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Approval Date
                      </td>
                      <td className="px-4  h-[48px] py-2 border border-white">
                        <div className="flex gap-3 items-center">
                          <p className="text-text1 font-semibold text-[14px]">
                            {formatDate(
                              policyById?.data?.otherInformation
                                ?.approvedDate || ''
                            )}
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr className="bg-gray1">
                      {/* Example row */}
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Approved By
                      </td>
                      <td className="px-4 w-[30%] h-[48px] py-2 border border-white">
                        <div className="flex w-[30%] gap-2 items-center bg-gray2 p-3 rounded-xl">
                          <Icon
                            name={'IconUserCircle'}
                            stroke={'#02698C'}
                            strokeWidth={1.2}
                            width={16}
                            height={16}
                          />
                          <p className="text-sm font-semibold leading-6 text-text5">
                            {policyById?.data?.otherInformation?.approvedBy}
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr className="bg-gray1">
                      {/* Example row */}
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Commence Date
                      </td>
                      <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                        {formatDate(
                          policyById?.data?.otherInformation?.commenceDate?.substring(
                            0,
                            16
                          ) || ''
                        )}
                      </td>
                    </tr>
                    <tr className="bg-gray1">
                      {/* Example row */}
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Last Review Date
                      </td>
                      <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                        {formatDate(
                          policyById?.data?.otherInformation?.lastReviewDate?.substring(
                            0,
                            16
                          ) || ''
                        )}
                      </td>
                    </tr>
                    <tr className="bg-gray1">
                      {/* Example row */}
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Next Review Date
                      </td>
                      <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                        {formatDate(
                          policyById?.data?.otherInformation?.nextReviewDate?.substring(
                            0,
                            16
                          ) || ''
                        )}
                      </td>
                    </tr>

                    {/* Add more rows as needed */}
                  </tbody>
                </table>
              </div>
            </div>
            {containsPolicyId(policiesAgreement.data || [], id) == false && (
              <div className="p-4 flex flex-1 flex-col border border-gray3 gap-4 rounded-2xl">
                <p className="text-sm font-semibold leading-6 text-text2">
                  I confirm that I have read and understood the policy document
                </p>
                <UICheckbox
                  label={'I agree'}
                  checked={isChecked}
                  onChange={() => setIsChecked(!isChecked)}
                />
              </div>
            )}
          </div>

          {containsPolicyId(policiesAgreement.data || [], id) == false && (
            <>
              <div className="bg-gray3 w-full h-[1px] my-3"></div>
              <div className="w-[33%] mt-6">
                <UIButton
                  onClick={addPolicyAgreement}
                  disabled={!isChecked}
                  label="Submit"
                />
              </div>
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default Policies
